import React from "react";
import {
  Grid,
  TextField,
  MenuItem,
  InputAdornment,
  Button,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import AddIcon from "@mui/icons-material/Add";

const PlayersToolbar = ({
  players,
  searchQuery,
  setSearchQuery,
  selectedPosition,
  setSelectedPosition,
  handleAdd,
  inputStyles,
  teamName = "Team",
}) => {
  const uniquePositions = Array.from(new Set(players.map((p) => p.position)));

  return (
    <Grid container spacing={2} sx={{ mt: 5, alignItems: "center" }}>
      <Typography>{`(${players.length}) Players on ${teamName}`}</Typography>

      <Grid item xs={12} sm={6} md={3}>
        <TextField
          fullWidth
          label="Search all players"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          sx={inputStyles}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={2}>
        <TextField
          select
          fullWidth
          label="All Positions"
          value={selectedPosition}
          onChange={(e) => setSelectedPosition(e.target.value)}
          sx={inputStyles}
          SelectProps={{
            IconComponent: KeyboardArrowDownIcon,
          }}
        >
          <MenuItem value="">All Positions</MenuItem>
          {uniquePositions.map((position) => (
            <MenuItem key={position} value={position}>
              {position}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      <Grid
        item
        xs={12}
        md="auto"
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          sx={{ borderRadius: "10px", height: 52, minWidth: 200 }}
          startIcon={<AddIcon />}
          onClick={handleAdd}
        >
          Add Player
        </Button>
      </Grid>
    </Grid>
  );
};

export default PlayersToolbar;
